import { useQuery } from "@tanstack/react-query"
import BaseHeadBanner from "../../../components/elements/BaseHeadBanner"
import BasePage from "../../../components/layout/BasePage"

import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api"
import { GeneralQueryKeys, GOOGLE_MAPS_API_KEY } from "../../../api/constants"
import { getAllObjectAddresses } from "../api/apiCalls"
import { useMemo } from "react"
import { adressType } from "../../../data/Types"
import { returnAddressString } from "../../../services/functions"
import Loading from "../../../components/common/Loading"
import ErrorPage from "../../404/ErrorPage"

export default function KartePage() {
    const {
        error: allObjectsE,
        data: allObjectsD,
        isLoading: allObjectsL,
    } = useQuery({
        queryKey: [GeneralQueryKeys.OBJECTS_ADDRESS_ONLY],
        queryFn: getAllObjectAddresses,
    })
    const markers = useMemo<adressType[]>(() => allObjectsD?.map((item: any) => item.adress), [allObjectsD])

    return (
        <BasePage nopadding="p-0">
            <BaseHeadBanner title={"Karte"} classProps="m-4 w-[calc(100%-2rem)] absolute top-12 z-10" />
            <div className="absolute top-0 w-full h-full">
                {allObjectsE && <ErrorPage />}
                {allObjectsL && <Loading />}
                {!allObjectsE && !allObjectsL && allObjectsD && (
                    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
                        <GoogleMap
                            mapContainerStyle={{ width: "100%", height: "100%" }}
                            center={{
                                lat: 51.0493286, // Beispielkoordinaten (Dresden)
                                lng: 13.7381437,
                            }}
                            zoom={13}>
                            {markers.map((marker, index) => (
                                <Marker
                                    key={index}
                                    position={{ lat: marker?.coordinates?.latitude ?? 0, lng: marker?.coordinates?.longitude ?? 0 }}
                                    title={returnAddressString(marker)}
                                />
                            ))}
                        </GoogleMap>
                    </LoadScript>
                )}
            </div>
        </BasePage>
    )
}
